const Section = ({ children, className = '', style = {} }) => {
  return (
    <section
      style={style}
      className={`w-full
                  px-4 sm:px-6 md:px-12 lg:px-16 xl:px-24 2xl:px-32
                  py-8 sm:py-12 md:py-16 lg:py-24 xl:py-32 2xl:py-40
                  sm:min-h-0 min-h-auto md:min-h-screen
                  flex flex-col items-center justify-center
                  overflow-hidden
                  mobile-centered-section

                  ${className}`}
    >
      {children}
    </section>
  );
};

export default Section;
